export const programGovernanceTour = {
    module: 'program_governance',
    title: 'Program Governance Tour',
    title_vi: 'Tour Quản trị chương trình',
    description: "As the Internal Audit Lead (P-VN-10), assess your organization's internal compliance maturity, track evidence gaps, and produce board-ready summaries -- distinct from Vendor Risk, which evaluates third-party processors.",
    description_vi: "Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Internal Audit Lead (P-VN-10), assess your organization's internal compliance maturity, track evidence gaps, and produce board-ready summaries -- distinct from Vendor Risk, which evaluates third-party processors.",
    estimated_duration_seconds: 90,
    steps: [
        {
            step_id: 'pg_dashboard',
            navigate_to: '/admin/program-governance/dashboard-config',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Program Governance Dashboard',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Program Governance Dashboard',
            description: "As the Internal Audit Lead, you will configure this dashboard to track your organization's internal compliance maturity -- not third-party vendor risk, which lives in the Vendor Risk module.",
            description_vi: "Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Internal Audit Lead, you will configure this dashboard to track your organization's internal compliance maturity -- not third-party vendor risk, which lives in the Vendor Risk module.",
            position: 'bottom',
        },
        {
            step_id: 'pg_subnav',
            target: '.dm-tabs',
            title: 'Sub-module Navigation',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Sub-module Navigation',
            description: 'Navigate between Maturity Models, Assessments, Evidence Gaps, Executive Summaries, and more. Each sub-module contributes to a holistic view of your internal program health.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Navigate between Maturity Models, Assessments, Evidence Gaps, Executive Summaries, and more. Each sub-module contributes to a holistic view of your internal program health.',
            position: 'bottom',
        },
        {
            step_id: 'pg_models',
            navigate_to: '/admin/program-governance/models',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Maturity Models',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Maturity Models',
            description: 'Define maturity models with named levels and criteria to benchmark your internal privacy program against industry standards like NIST Privacy Framework or ISO 27701.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define maturity models with named levels and criteria to benchmark your internal privacy program against industry standards like NIST Privacy Framework or ISO 27701.',
            position: 'bottom',
        },
        {
            step_id: 'pg_create_model',
            target: '.dm-header .btn-primary',
            title: 'Create a Maturity Model',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Maturity Model',
            description: 'Click here to define a new maturity model. Each model becomes a reusable benchmark for periodic self-assessments.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click here to define a new maturity model. Each model becomes a reusable benchmark for periodic self-assessments.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'pg_model_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Maturity Model Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Maturity Model Form',
            description: 'Enter the model name and optional description. Models define the scoring framework your assessments will use to measure internal compliance posture.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Enter the model name and optional description. Models define the scoring framework your assessments will use to measure internal compliance posture.',
            position: 'right',
        },
        {
            step_id: 'pg_assessments',
            navigate_to: '/admin/program-governance/assessments',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Maturity Assessments',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Maturity Assessments',
            description: "Run periodic self-assessments against your maturity models. Unlike Vendor Risk assessments (which score third parties), these evaluate your own organization's compliance capabilities.",
            description_vi: "Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Run periodic self-assessments against your maturity models. Unlike Vendor Risk assessments (which score third parties), these evaluate your own organization's compliance capabilities.",
            position: 'bottom',
        },
        {
            step_id: 'pg_create_assessment',
            target: '.dm-header .btn-primary',
            title: 'Start a New Assessment',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Start a New Assessment',
            description: 'Click here to launch a new internal maturity assessment for the current review period.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click here to launch a new internal maturity assessment for the current review period.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'pg_assessment_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Assessment Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Assessment Form',
            description: 'Set the title, select a maturity model, define the review period, and choose an approval mode. Assessment results feed into the gap register and executive summaries.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Set the title, select a maturity model, define the review period, and choose an approval mode. Assessment results feed into the gap register and executive summaries.',
            position: 'right',
        },
        {
            step_id: 'pg_evidence_gaps',
            navigate_to: '/admin/program-governance/evidence-gaps',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Evidence Gaps',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Evidence Gaps',
            description: 'The gap register tracks where supporting evidence is missing, outdated, or insufficient. As the Internal Audit Lead, prioritize these gaps to close before the next regulatory inspection.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: The gap register tracks where supporting evidence is missing, outdated, or insufficient. As the Internal Audit Lead, prioritize these gaps to close before the next regulatory inspection.',
            position: 'bottom',
        },
        {
            step_id: 'pg_create_gap',
            target: '.dm-header .btn-primary',
            title: 'Log an Evidence Gap',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Log an Evidence Gap',
            description: 'Click here to log a gap discovered during an assessment or audit. Each gap tracks severity, ownership, and remediation target date.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click here to log a gap discovered during an assessment or audit. Each gap tracks severity, ownership, and remediation target date.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'pg_gap_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Evidence Gap Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Evidence Gap Form',
            description: 'Select the affected module, describe the gap, set severity, assign an owner, and set a remediation deadline. This creates a trackable action item linked to your maturity assessment.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Select the affected module, describe the gap, set severity, assign an owner, and set a remediation deadline. This creates a trackable action item linked to your maturity assessment.',
            position: 'right',
        },
        {
            step_id: 'pg_summaries',
            navigate_to: '/admin/program-governance/summaries',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Executive Summaries',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Executive Summaries',
            description: 'Generate board-ready summaries from assessment results. These reports give leadership a clear view of compliance posture, open gaps, and recommended actions.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Generate board-ready summaries from assessment results. These reports give leadership a clear view of compliance posture, open gaps, and recommended actions.',
            position: 'bottom',
        },
        {
            step_id: 'pg_generate_summary',
            target: '.dm-header .btn-primary',
            title: 'Generate a Summary',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Generate a Summary',
            description: 'Click here to generate a summary for the selected reporting period. The system drafts the narrative from your assessment data.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click here to generate a summary for the selected reporting period. The system drafts the narrative from your assessment data.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'pg_summary_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Summary Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Summary Form',
            description: 'Select the reporting period and language. Review and edit the draft before publishing to ensure it accurately represents your compliance posture to the board.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Select the reporting period and language. Review and edit the draft before publishing to ensure it accurately represents your compliance posture to the board.',
            position: 'right',
        },
        {
            step_id: 'pg_readiness',
            navigate_to: '/admin/program-governance/readiness',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Audit Readiness',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Audit Readiness',
            description: 'View a calculated readiness score based on open gaps, assessment results, and evidence coverage. This score tells you how prepared your organization is for the next regulatory audit.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: View a calculated readiness score based on open gaps, assessment results, and evidence coverage. This score tells you how prepared your organization is for the next regulatory audit.',
            position: 'bottom',
        },
        {
            step_id: 'pg_recalculate',
            target: '.dm-header .btn-primary',
            title: 'Recalculate Readiness Score',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Recalculate Readiness Score',
            description: 'Click here to refresh the readiness score on demand after closing gaps or completing assessments. The score reflects control coverage, open gaps, and overall readiness percentage.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click here to refresh the readiness score on demand after closing gaps or completing assessments. The score reflects control coverage, open gaps, and overall readiness percentage.',
            position: 'bottom',
        },
        {
            step_id: 'pg_trends',
            navigate_to: '/admin/program-governance/trends',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Trend Dashboard',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Trend Dashboard',
            description: 'Track how your internal maturity scores evolve over time. Upward trends demonstrate continuous improvement to regulators; downward trends signal areas needing immediate attention.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Track how your internal maturity scores evolve over time. Upward trends demonstrate continuous improvement to regulators; downward trends signal areas needing immediate attention.',
            position: 'bottom',
        },
        {
            step_id: 'pg_periods',
            navigate_to: '/admin/program-governance/reporting-periods',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Reporting Periods',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Reporting Periods',
            description: "Define the time windows that structure your assessment and reporting cadence. Align these with your organization's regulatory calendar.",
            description_vi: "Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define the time windows that structure your assessment and reporting cadence. Align these with your organization's regulatory calendar.",
            position: 'bottom',
        },
        {
            step_id: 'pg_new_period',
            target: '.dm-header .btn-primary',
            title: 'Create a Reporting Period',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Reporting Period',
            description: 'Click here to manually create a reporting period aligned with your audit or regulatory cycle.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click here to manually create a reporting period aligned with your audit or regulatory cycle.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'pg_period_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Reporting Period Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Reporting Period Form',
            description: 'Enter the period label, start date, and end date. Optionally set a cadence to auto-generate future periods matching your compliance review schedule.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Enter the period label, start date, and end date. Optionally set a cadence to auto-generate future periods matching your compliance review schedule.',
            position: 'right',
            action: { type: 'click', target: '.dm-form-actions button[type="button"]' },
        },
        {
            step_id: 'pg_auto_period',
            target: '.dm-header .btn-sm',
            title: 'Auto-Generate Periods',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Auto-Generate Periods',
            description: 'Bulk-create multiple periods at once by selecting a cadence and count. Useful for setting up a full year of quarterly assessments in one step.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Bulk-create multiple periods at once by selecting a cadence and count. Useful for setting up a full year of quarterly assessments in one step.',
            position: 'bottom',
        },
        {
            step_id: 'pg_health',
            navigate_to: '/admin/program-governance/health',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Program Health',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Program Health',
            description: 'At-a-glance overview of your internal governance program: maturity scores, outstanding actions, and health indicators that signal whether you are audit-ready.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: At-a-glance overview of your internal governance program: maturity scores, outstanding actions, and health indicators that signal whether you are audit-ready.',
            position: 'bottom',
        },
        {
            step_id: 'pg_complete',
            target: '.dm-page',
            title: 'Program Governance Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Program Governance Tour Complete',
            description: 'You can now assess internal maturity, track evidence gaps in the gap register, generate board-ready summaries, and monitor audit readiness -- producing the evidence trail that demonstrates continuous compliance improvement.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now assess internal maturity, track evidence gaps in the gap register, generate board-ready summaries, and monitor audit readiness -- producing the evidence trail that demonstrates continuous compliance improvement.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=program-governance.js.map